<script setup>
import {computed} from "vue";
import { useAuth0 } from "@auth0/auth0-vue";
import { onMounted, onBeforeUnmount } from 'vue';
// import VueJwtDecode from 'vue-jwt-decode'
import { useRouter } from 'vue-router';
import {useDataStore} from "@/Stores/dataStore";
import { useOrderStore } from "@/Stores/orders.js";
import { eventBus } from "@/Javascript/eventBus.js"

import PermissionsModule from "@/Javascript/PermissionsModule";
import modalManager from "@/Javascript/ModalManager";
import ContactFooter from '@/components/ContactFooter.vue'

const router = useRouter()
const dataStore = useDataStore()
const orderStore = useOrderStore();

const order_length = computed(()=>{
  let length = 0
  for(const item of orderStore.order.items){
    length += item.quantity
  }
  return length
})



// const { loginWithRedirect, logout, user, isAuthenticated } = useAuth0();
const { loginWithRedirect, logout, isAuthenticated } = useAuth0();

function login() {
  loginWithRedirect();
}
function logoutFunction() {
  logout({ returnTo: window.location.origin });
}


function gotoDashboard(){
  eventBus.dispatchEvent(new CustomEvent('dashboard-clicked')
  )
  router.push({
    path:'/Dashboard'
  })
}


// async function setupToken() {
//   // Wait until Auth0 is done loading
//   while (auth.isLoading.value) {
//     await new Promise(resolve => setTimeout(resolve, 50));
//   }
//
//   // Only try to get token if user is authenticated
//   if (auth.isAuthenticated.value) {
//     try {
//       const token = await auth.getAccessTokenSilently();
//
//       callApi().setToken(token);
//     } catch (err) {
//       console.error("Failed to get token:", err);
//       await auth.loginWithRedirect();
//     }
//   }
// }





// async function checkToken() {
//   try {
//     // Get the token
//     const token = callApi().getToken()
//
//     if (token) {
//       // Decode the token
//       const decodedToken = VueJwtDecode.decode(token);
//       const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
//
//       // Check if the token is expired
//       if(decodedToken.exp < currentTime){
//         callApi().setToken(await useAuth0().getAccessTokenSilently())
//       }
//     }
//
//   } catch (error) {
//     console.log(error)
//   }
// }

// setInterval(async () => {
//   try {
//     if(isAuthenticated.value){
//       callApi().setToken(await useAuth0().getAccessTokenSilently())
//     }
//   } catch {
//     // silent refresh failed, session may have expired
//   }
// }, 5 * 60 * 1000) // every 5 minutes


function handleModalHidden() {
  modalManager.restoreModal();
}

function handleModalShown(event){
  modalManager.modalOpened(event.target)
}


// This was added so that pressing the back button causes open modals to close instead of going to the previous page.
router.beforeEach(()=>{
  return modalManager.handleBackButton()
})

onMounted(()=>{
  PermissionsModule.updatePermissions()
  dataStore.fetchData()
  // window.addEventListener('focus', checkToken)
  document.addEventListener('hidden.bs.modal', handleModalHidden);
  document.addEventListener('shown.bs.modal', handleModalShown)

})

onBeforeUnmount(() => {
  document.removeEventListener('hidden.bs.modal', handleModalHidden);
  document.removeEventListener('shown.bs.modal', handleModalShown)
});

// command to run project: npm run serve
</script>

<template>
  <div class="d-flex flex-column">

    <nav class="navbar navbar-expand-lg navbar-dark sticky-top fixed-top" id="nav">
    <div class="container-fluid">
    <router-link class="navbar-brand m-0" to="/">
      <img src="@/assets/logo.png" alt="Logo" height="35">
    </router-link>

    <div class="navbar-nav">
      <div v-if="isAuthenticated" class="nav-item">
<!--        <router-link v-if="PermissionsModule.hasPermission('isEmployee')" to="/Dashboard" class="nav-link">-->
<!--          Dashboard-->
<!--        </router-link>-->
        <span v-if="PermissionsModule.hasPermission('isEmployee')" @click="gotoDashboard" class="nav-link" style="cursor: pointer">
          Dashboard
        </span>
      </div>
    </div>


    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse bg-dark" id="navbarSupportedContent" style="flex-grow: 0">
        <ul class="navbar-nav ms-auto">

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Vehicle Programming
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li> <router-link to="/MobileProgramming" class="nav-link">Mobile Vehicle Programming</router-link></li>
              <li> <router-link to="/MobileProgramming/CheckUpdates" class="nav-link">Check For Vehicle Software Updates</router-link></li>
              <li> <router-link to="/MobileProgramming/RequestProgramming" class="nav-link">Request Programming</router-link></li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Shop
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
    <!--              <li> <router-link to="/Modules" class="nav-link">How It Works</router-link></li>-->
              <li> <router-link to="/Shop/Modules" class="nav-link">Browse Modules</router-link></li>
              <li> <router-link to="/Shop/Tools" class="nav-link">Programming Tools</router-link></li>
              <li> <router-link to="/Shop/Cables" class="nav-link">Cables</router-link></li>
              <li> <router-link to="/Shop/Connector Harnesses" class="nav-link">Connector Harnesses</router-link></li>
              <li> <router-link to="/Shop/Classes" class="nav-link">Training Classes</router-link></li>
            </ul>
          </li>

          <li class="nav-item">
            <router-link to="/Events" class="nav-link">Events</router-link>
          </li>

          <li class="nav-item">
            <router-link to="/ResourceCenter" class="nav-link">Resource Center</router-link>
          </li>

          <li class="nav-item" v-if="PermissionsModule.hasPermission('isEmployee')">
            <router-link to="/EmployeePortal" class="nav-link">Employee Portal</router-link>
          </li>

          <li class="nav-item dropdown" v-if="isAuthenticated">
            <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
              Account
            </a>
            <ul class="dropdown-menu dropdown-menu-end custom-dropdown" aria-labelledby="navbarDropdown">
              <li> <router-link to="/Account/Contact" class="nav-link">Profile</router-link></li>
              <li> <router-link to="/Account/MyOrders" class="nav-link">Orders</router-link></li>
              <li> <router-link to="/Account/MyRequests" class="nav-link">Programming Requests</router-link></li>
              <li><button class="btn btn-primary w-100" @click="logoutFunction">Logout</button></li>
            </ul>
          </li>

          <!-- CART -->
          <li class="nav-item me-2">
            <router-link to="/Shop/Cart" class="nav-link position-relative">
              🛒
              <span v-if="order_length"
                    class="badge bg-danger position-absolute mt-1"
                    style="padding: 3px 5px 3px 5px; transform: translate(-20%, -85%);"
              >
                  {{order_length}}
                </span>
            </router-link>
          </li>

        </ul>
        <div class="nav-item ms-2" v-if="!isAuthenticated">
          <button class="btn btn-primary" @click="login">Login</button>
        </div>


      </div>


    </div>
    </nav>


    <router-view/>



    <ContactFooter/>
  </div>

</template>

<style src="@vueform/multiselect/themes/default.css"></style>

<style>
@import '~bootstrap-icons/font/bootstrap-icons.css';


.main-container {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  /*padding: 0px 5px 0px 5px;*/
}

.header {
  margin-bottom: 1.5rem ;
}
.footer {
  margin-bottom: 1rem ;
  margin-top: 1rem;
}

.flexible-middle {
  flex-grow: 1 !important;
  overflow: auto !important;
}

.clear-translate{
  translate: -35px;
  padding: 0px;
}

/* Increase navbar height */
.navbar {
  min-height: 70px; /* default is ~56px */
  padding-top: 1rem;
  padding-bottom: 1rem;
}

/* Increase text size */
.navbar .nav-link,
.navbar-brand {
  font-size: 1.2rem; /* default is 1rem (16px) */
}

.dropdown-menu {
  min-width: max-content !important;
  width: auto !important;
  border: 1px solid !important; /* subtle orange border */
  border-radius: 0.5rem !important; /* slightly rounded corners */
  padding: 0.5rem !important; /* inner spacing */
}


</style>


